/**
 * SA / 社員 自身のプロフィール編集ページ (v3.2.14 / Phase 3a)。
 *
 * URL: /sa/profile
 *
 * 仕様:
 *   - currentUser.uid に対する UserDetailPage 相当の編集 UI を提供
 *   - 振込口座 / 請求先・納品先住所 / 適格請求書発行事業者登録番号 を本人が編集
 *   - 管理者画面 (/admin/users/:uid) は owner / 同部署 leader しか辿れないため、
 *     SA がアクセスできる独立ルートが必要
 *
 * 実装: 既存 UserDetailPage は useParams から uid を取り、isSelf 判定で本人編集可能 →
 *     ここでは currentUser.uid を URL パラメータとして与えるリダイレクトラッパー
 */
import { Navigate } from 'react-router-dom';

import { Screen } from '@/components/layout/Screen';
import { Spinner } from '@/components/ui/spinner';
import { useAuth } from '@/hooks/useAuth';
import { paths } from '@/routes/paths';

export function SaProfilePage() {
  const { user, status } = useAuth();

  if (status === 'loading') {
    return (
      <Screen title="読み込み中…">
        <Spinner />
      </Screen>
    );
  }
  if (!user?.uid) {
    return <Navigate to="/login" replace />;
  }
  return (
    <Navigate
      to={paths.adminUserDetail.replace(':uid', user.uid)}
      replace
    />
  );
}
